import React from "react";
import "./Privacy.css"; 
import PageSEO from '../components/PageSEO';

function Terms() {
  return (
    <>
    <PageSEO page="terms" />
    <div className="policy-page">
      <section className="policy-hero">
        <h1>Terms of Service</h1>
        <p>Last updated: June 1, 2026</p>
      </section>

      <div className="policy-body">
        <section className="policy-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using the Keystone Insurance Brokers Ltd website ("Site"), you agree to
            be bound by these Terms of Service and all applicable laws and regulations. If you do not
            agree with any of these terms, you are prohibited from using or accessing this Site.
          </p>
        </section>

        <section className="policy-section">
          <h2>2. Services Provided</h2>
          <p>
            Keystone Insurance Brokers Ltd is a licensed insurance brokerage operating in British
            Columbia, Canada. Our website provides general information about our insurance services
            and allows users to request quotes or contact our team. Nothing on this Site constitutes
            a binding insurance contract or guarantee of coverage.
          </p>
        </section>

        <section className="policy-section">
          <h2>3. Use of the Website</h2>
          <p>You agree to use this Site only for lawful purposes. You must not:</p>
          <ul>
            <li>Use the Site in any way that violates applicable local, national, or international laws.</li>
            <li>Transmit any unsolicited or unauthorized advertising or promotional material.</li>
            <li>Attempt to gain unauthorized access to any part of the Site or its servers.</li>
            <li>Introduce any malicious code, viruses, or harmful material to the Site.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>4. No Insurance Advice</h2>
          <p>
            The information provided on this Site is for general informational purposes only and
            does not constitute professional insurance advice. Policy details, coverage terms, and
            premiums are subject to individual assessment by our licensed brokers and the applicable
            insurance carrier. We encourage you to contact us directly for personalized advice.
          </p>
        </section>

        <section className="policy-section">
          <h2>5. Accuracy of Information</h2>
          <p>
            While we strive to keep the information on our Site accurate and up to date, we make no
            warranties or representations of any kind, express or implied, about the completeness,
            accuracy, reliability, or suitability of the information on this Site. Any reliance you
            place on such information is strictly at your own risk.
          </p>
        </section>

        <section className="policy-section">
          <h2>6. Intellectual Property</h2>
          <p>
            All content on this Site — including text, graphics, logos, and images — is the property
            of Keystone Insurance Brokers Ltd and is protected by applicable copyright and intellectual
            property laws. You may not reproduce, distribute, or create derivative works without our
            express written permission.
          </p>
        </section>

        <section className="policy-section">
          <h2>7. Third-Party Links</h2>
          <p>
            Our Site may contain links to third-party websites for your convenience. These links do
            not signify our endorsement of those sites. We have no responsibility for the content
            of linked external sites and are not liable for any damages or losses arising from your
            use of them.
          </p>
        </section>

        <section className="policy-section">
          <h2>8. Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by law, Keystone Insurance Brokers Ltd shall not be
            liable for any indirect, incidental, special, or consequential damages arising from your
            use of, or inability to use, our Site or services — even if we have been advised of the
            possibility of such damages.
          </p>
        </section>

        <section className="policy-section">
          <h2>9. Governing Law</h2>
          <p>
            These Terms of Service are governed by and construed in accordance with the laws of the
            Province of British Columbia and the federal laws of Canada applicable therein. Any
            disputes arising under these terms shall be subject to the exclusive jurisdiction of the
            courts of British Columbia.
          </p>
        </section>

        <section className="policy-section">
          <h2>10. Changes to These Terms</h2>
          <p>
            We reserve the right to modify these Terms of Service at any time. Changes will be
            effective immediately upon posting to the Site. Your continued use of the Site following
            any changes constitutes your acceptance of the new terms.
          </p>
        </section>

        <section className="policy-section">
          <h2>11. Contact Us</h2>
          <p>If you have any questions about these Terms of Service, please contact us:</p>
          <div className="policy-contact-block">
            <p><strong>Keystone Insurance Brokers Ltd</strong></p>
            <p>103-8077 King George Blvd, Surrey, BC, Canada V3W 5B4</p>
            <p>Phone: (604) 595-8666</p>
            <p>Email: <a href="mailto:Keystoneins@shaw.ca">Keystoneins@shaw.ca</a></p>
          </div>
        </section>
      </div>
    </div>
    </>
  );
}

export default Terms;
